/*
    Init bootstrap custom file input
*/

jQuery(document).ready(function () {
    
    var
        fileInputs = jQuery('.custom-file-input')
    ;
    
    if (fileInputs.length == 0) {
        return;
    }

    bsCustomFileInput.init();
    
});